/* KBW stone grid.
 *
 * Custom script: not part of the Maximize theme, so a theme update will
 * never overwrite it. Built on assets/kbw-flooring-grid.js, with one real
 * difference: a card can carry several values for one field (a design is
 * sold in several slab sizes), stored as "|110"x26"|110"x36"|". A card
 * matches a group when it carries ANY of the ticked values; across groups
 * every group must agree.
 *
 * Every card is already in the page, printed server-side. This only hides
 * the ones a filter has ruled out and reorders the ones a sort has asked
 * for -- no fetch, no re-render.
 */
(function () {
  'use strict';

  document.querySelectorAll('[data-kbw-st]').forEach(initStoneGrid);

  function initStoneGrid(root) {
    var grid = root.querySelector('[data-kbw-st-grid]');
    var cards = Array.prototype.slice.call(root.querySelectorAll('[data-kbw-st-card]'));
    var originalOrder = cards.slice();
    var checkboxes = Array.prototype.slice.call(root.querySelectorAll('[data-kbw-st-filter]'));
    var countEl = root.querySelector('[data-kbw-st-count]');
    var emptyEl = root.querySelector('[data-kbw-st-empty]');
    var resetBtn = root.querySelector('[data-kbw-st-reset]');
    var sortSelect = root.querySelector('[data-kbw-st-sort]');
    var countLabel = root.getAttribute('data-count-label') || '[count]';
    var countLabelOne = root.getAttribute('data-count-label-one') || countLabel;

    if (!grid || !cards.length) return;

    // --- filter groups ---------------------------------------------------------
    function facetOf(cb) {
      return cb.getAttribute('data-facet');
    }

    // "|a|b|" -> ['a', 'b']. Read once per card and facet, then cached.
    var cache = new Map();
    function cardValues(card, facet) {
      var key = facet;
      var perCard = cache.get(card);
      if (!perCard) { perCard = {}; cache.set(card, perCard); }
      if (perCard[key]) return perCard[key];
      var raw = card.getAttribute('data-f-' + facet.replace(/_/g, '-')) || '';
      var list = raw.split('|').filter(function (v) { return v !== ''; });
      perCard[key] = list;
      return list;
    }

    function selections() {
      var groups = {};
      checkboxes.forEach(function (cb) {
        if (!cb.checked) return;
        var facet = facetOf(cb);
        (groups[facet] = groups[facet] || []).push(cb.value);
      });
      return groups;
    }

    function passes(card, groups, skipFacet) {
      return Object.keys(groups).every(function (facet) {
        if (facet === skipFacet) return true;
        var own = cardValues(card, facet);
        return groups[facet].some(function (v) { return own.indexOf(v) !== -1; });
      });
    }

    // Values arrive in the order the products were met. Where every option in
    // a group carries numbers, put them in number order -- comparing every
    // number in turn, so 110"x26" < 110"x36" < 126"x63".
    function numbersOf(text) {
      return (text.match(/\d+(?:\.\d+)?/g) || []).map(parseFloat);
    }
    Array.prototype.forEach.call(root.querySelectorAll('[data-kbw-st-group]'), function (group) {
      var list = group.querySelector('[data-kbw-rail-options]') || group;
      var opts = Array.prototype.slice.call(list.querySelectorAll('.kbw-rail__check'));
      var nums = opts.map(function (o) { return numbersOf(o.querySelector('input').value); });
      if (nums.some(function (n) { return !n.length; })) return;
      opts
        .map(function (o, i) { return { o: o, n: nums[i] }; })
        .sort(function (a, b) {
          var len = Math.max(a.n.length, b.n.length);
          for (var i = 0; i < len; i++) {
            var d = (a.n[i] || 0) - (b.n[i] || 0);
            if (d !== 0) return d;
          }
          return 0;
        })
        .forEach(function (x) { list.appendChild(x.o); });
    });

    function applyFilter() {
      var groups = selections();
      var anyTicked = Object.keys(groups).length > 0;
      var visible = 0;
      cards.forEach(function (card) {
        var show = passes(card, groups, null);
        card.hidden = !show;
        if (show) visible += 1;
      });
      checkboxes.forEach(function (cb) {
        var facet = facetOf(cb);
        var n = 0;
        cards.forEach(function (card) {
          if (cardValues(card, facet).indexOf(cb.value) !== -1 && passes(card, groups, facet)) n += 1;
        });
        var opt = cb.closest ? cb.closest('.kbw-rail__check') : null;
        var optCount = opt ? opt.querySelector('[data-kbw-st-optcount]') : null;
        if (optCount) optCount.textContent = n;
        var dead = n === 0 && !cb.checked;
        cb.disabled = dead;
        if (opt) opt.classList.toggle('is-empty', dead);
      });
      if (countEl) {
        // The number reads a step heavier than the words around it, the way
        // the cabinet list's count does; the words are the editor's text.
        var words = (visible === 1 ? countLabelOne : countLabel).split('[count]');
        countEl.textContent = '';
        words.forEach(function (part, i) {
          if (i > 0) {
            var b = document.createElement('b');
            b.textContent = visible;
            countEl.appendChild(b);
          }
          if (part) countEl.appendChild(document.createTextNode(part));
        });
      }
      if (emptyEl) emptyEl.hidden = visible !== 0;
      if (resetBtn) resetBtn.hidden = !anyTicked;
      if (window.KbwRail) window.KbwRail.refresh(root);
    }

    checkboxes.forEach(function (cb) {
      cb.addEventListener('change', applyFilter);
    });

    if (resetBtn) {
      resetBtn.addEventListener('click', function () {
        checkboxes.forEach(function (cb) { cb.checked = false; });
        applyFilter();
      });
    }

    if (sortSelect) {
      sortSelect.addEventListener('change', function () {
        var value = sortSelect.value;
        var price = function (c) {
          var p = parseInt(c.dataset.price, 10) || 0;
          // A design with no price sorts last whichever way the list runs.
          return p > 0 ? p : null;
        };
        var sorted;
        if (value === 'price-asc' || value === 'price-desc') {
          var dir = value === 'price-asc' ? 1 : -1;
          sorted = cards.slice().sort(function (a, b) {
            var pa = price(a);
            var pb = price(b);
            if (pa === null && pb === null) return 0;
            if (pa === null) return 1;
            if (pb === null) return -1;
            return (pa - pb) * dir;
          });
        } else if (value === 'title') {
          sorted = cards.slice().sort(function (a, b) {
            return a.dataset.title.localeCompare(b.dataset.title, undefined, { numeric: true });
          });
        } else if (value === 'newest') {
          sorted = cards.slice().sort(function (a, b) {
            return (parseInt(b.dataset.created, 10) || 0) - (parseInt(a.dataset.created, 10) || 0);
          });
        } else {
          sorted = originalOrder.slice();
        }
        sorted.forEach(function (card) { grid.appendChild(card); });
      });
    }

    // --- the rail, "Show more" and the phone drawer ---------------------------
    // KBW: assets/kbw-filter-rail.js, the site's one filter rail standard
    // (client, 2026-09-15). What is left here is this list's own filtering.

    // --- a value pre-selected from the URL -----------------------------------
    // ?slab_size=126"x63" (or any other printed group's key) lands on the
    // list already filtered. An unknown key or value leaves every card showing.
    try {
      var params = new URLSearchParams(window.location.search);
      checkboxes.forEach(function (cb) {
        var wanted = params.getAll(facetOf(cb));
        if (wanted.indexOf(cb.value) !== -1) cb.checked = true;
      });
    } catch (e) {
      /* URLSearchParams missing or malformed query string -- leave everything showing */
    }
    applyFilter();
  }
})();
